import { yupResolver } from '@hookform/resolvers/yup';
import { Button, NotificationDispatch, TextField } from '@tryhackme/thm-ui-components';
import { useMemo } from 'react';
import { HttpStatus } from 'src/common/enums';
import { useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useUpdateForumThreadMutation } from 'src/features/manage-room/manage-room.slice';
import type { ManageRoomDetail } from 'src/features/manage-room/manage-room.types';
import { FormRow } from '../../../form-row';
import { forumThreadsValidations } from '../../write-ups.constants';
import type { ForumDetails, UpdateUserWriteUpsPayload } from '../../write-ups.types';
import { StyledLoadingSpinner } from './forum-thread.styles';
export const ForumThread = ({
  roomDetails
}: {
  roomDetails: ManageRoomDetail;
}) => {
  const [updateForumThread, {
    isLoading
  }] = useUpdateForumThreadMutation();
  const defaultValues = useMemo(() => ({
    forumLink: roomDetails?.forumLink || ''
  }), [roomDetails]);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    resolver: yupResolver(forumThreadsValidations),
    defaultValues,
    mode: 'onChange'
  });
  const onSubmit = async (values: ForumDetails) => {
    try {
      const {
        forumLink
      } = values;
      const updateWriteUpsPayload: UpdateUserWriteUpsPayload = {
        url: forumLink,
        code: roomDetails?.code || ''
      };
      await updateForumThread(updateWriteUpsPayload).unwrap();
      NotificationDispatch('success', 'Forum thread updated successfully.');
    } catch (error) {
      if (isQueryErrorWithMessage(error)) {
        if (error.status === HttpStatus.BAD_REQUEST) {
          NotificationDispatch('error', error.data.message);
        } else {
          NotificationDispatch('error', 'Uh-oh. There was an error while updating your forum thread. Please try again.');
        }
      }
    }
  };
  return <FormRow heading="Forum thread" showBottomLine={false} description="Have a dedicated room forum thread for others to discuss solutions or provide support for your room." data-sentry-element="FormRow" data-sentry-component="ForumThread" data-sentry-source-file="forum-thread.tsx">
      <TextField {...register('forumLink')} data-testid="forum_link" id="forum_link" variant="input" label="Thread URL" isError={Boolean(errors.forumLink)} errorMessage={errors?.forumLink?.message} rightOutsideAdornment={
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Button data-testid="action-button" variant="solid" color="add" onClick={handleSubmit(onSubmit)}>
            {isLoading && <StyledLoadingSpinner color="primary" />}
            {isLoading ? 'Updating' : 'Save'}
          </Button>} data-sentry-element="TextField" data-sentry-source-file="forum-thread.tsx" />
    </FormRow>;
};